"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Popups = /** @class */ (function (_super) {
    __extends(Popups, _super);
    function Popups(props) {
        return _super.call(this, props) || this;
    }
    Popups.prototype.render = function () {
        var _this = this;
        var popupBlocks = this.props.section.settings.allowmultiple
            ? this.props.section.blocks
            : this.props.section.blocks.filter(function (block) { return block.settings.enable == true; }).splice(0, 1);
        return popupBlocks.map(function (block, i) { return React.createElement(Snippets.PopupItem, __assign({ block: block }, _this.props, { key: i })); });
    };
    return Popups;
}(React.PureComponent));
exports.Popups = Popups;
